import { render, staticRenderFns } from "./ClassroomStreamTab.vue?vue&type=template&id=549e8afb&scoped=true&"
import script from "./ClassroomStreamTab.vue?vue&type=script&lang=js&"
export * from "./ClassroomStreamTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549e8afb",
  null
  
)

export default component.exports